import { API_URL, PRICE_SCHEME_HEADER } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { ItemModifierGroupsResponseBody } from './types';

export const getModifierGroups = async (
  priceSchemeId: string,
  limit: number = 50,
  name?: string,
  after_id?: string,
  menus?: string[],
): Promise<ItemModifierGroupsResponseBody> => {
  const url = new URL(`${API_URL}/items/modifier-groups?limit=${limit}`);

  if (after_id) {
    url.searchParams.append('after_id', after_id);
  }

  if (name) {
    url.searchParams.append('name', name);
  }

  if (menus && menus.length > 0) {
    url.searchParams.append('menus', menus.join(','));
  }

  try {
    const res = await fetch(url.toString(), {
      headers: {
        [PRICE_SCHEME_HEADER]: priceSchemeId,
      },
    });

    if (!res.ok) {
      throw new Error('We have been unable to complete your request. Please try again.');
    }

    const data: ItemModifierGroupsResponseBody = await res.json();
    return data;
  } catch (err) {
    throw new Error(err);
  }
};
